import { useEffect, useRef, useState } from "react";
import { FaFileCirclePlus, FaFolderPlus } from "react-icons/fa6";
import { MdAdd } from "react-icons/md";


const AddButtonMenu = ({ handleOpenModal, setActiveTab }) => {
    const [menuOpen, setMenuOpen] = useState(false);
    const menuRef = useRef(null);

    const toggleMenu = (e) => {
        e.stopPropagation();
        setMenuOpen((prev) => !prev);
    };

    useEffect(() => {
        const handleClickOutside = (event) => {
            if (menuRef.current && !menuRef.current.contains(event.target)) {
                setMenuOpen(false);
            }
        };
        document.addEventListener("mousedown", handleClickOutside);
        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, []);

    return (
        <div className="flex items-center text-gray-500 w-full justify-end font-semibold  relative" ref={menuRef}>
            <span
                className="flex items-center gap-1 !bg-[#AEF468] py-[10px] px-[16px] h-[30px] font-bold !rounded-[4px] cursor-pointer text-base text-[#000000]"
                onClick={toggleMenu}
            >
                <MdAdd size={23} color="black" />
                <span>New</span>
            </span>

            {menuOpen && (
                <div className="absolute right-[-13px] top-11 bg-white border shadow-lg rounded-md z-20 w-[200px]">
                    <button
                        onClick={() => {
                            setActiveTab('folders')
                            handleOpenModal();
                        }
                        }
                        className="block w-full !text-left px-4 py-3 text-sm text-[#0A121A] hover:bg-gray-100 border-b"
                    >
                        <span className="flex items-center justify-start gap-2"><FaFolderPlus size={21} />New Folder</span>

                    </button>
                    <button
                        onClick={() => {
                            setActiveTab('files')
                            handleOpenModal();
                        }
                        }
                        className="block w-full !text-left px-4 py-3 text-sm hover:bg-gray-100 text-[#0A121A]"
                    >
                        <span className="flex items-center justify-start gap-2"><FaFileCirclePlus size={21} />New File</span>
                    </button>
                </div>
            )}

        </div>
    );
};

export default AddButtonMenu;